export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 3.0,
        "transcript": "Naamikik'. Cameng kangilirluku tauna pikumteggu.",
        "translation": "I don't know. We should explain the meaning behind that."
    },
    "2": {
        "startTime": 3.5,
        "endTime": 7.4,
        "transcript": "Kangia tauna wii kangingumanritaqa tau͡gatnatullrunrilama.",
        "translation": "I don't know the meaning behind that because I've never done that."
    },
    "3": {
        "startTime": 7.5,
        "endTime": 12.9,
        "transcript": "Tauna wangkutni Kiatiirmiuni maani tuatnatuukut-llu.",
        "translation": "We from the upper Nushagak River also do that."
    },
    "4": {
        "startTime": 13.5,
        "endTime": 17.5,
        "transcript": "Makunek alingnarqellrianek pitaqamta qavani",
        "translation": "When we catch these dangerous animals upriver"
    },
    "5": {
        "startTime": 18.0,
        "endTime": 25.0,
        "transcript": "Taqukanek-llu tan'gerlinek-llu, tamakunek pit'eqerraaraqamta",
        "translation": "When we first catch bears, black bears, those things"
    },
    "6": {
        "startTime": 26.5,
        "endTime": 36.5,
        "transcript": "Imna auganek pitamta taum alingnarqellriim qanra aitarrluku",
        "translation": "The blood of that dangerous animal we caught, we open its mouth"
    },
    "7": {
        "startTime": 37.5,
        "endTime": 40.9,
        "transcript": "Nuaganek kautetuukut tegulluta.",
        "translation": "We reach in and take its saliva."
    },
    "8": {
        "startTime": 41.5,
        "endTime": 46.0,
        "transcript": "Nutaan-ll' unatemteńun pirraarluku kegginamteńun minguulluku.",
        "translation": "And then after putting it on our hands, we apply it to our faces."
    },
    "9": {
        "startTime": 46.9,
        "endTime": 50.0,
        "transcript": "Tua-i-gguq tamatum pitarkam tangerqunikut",
        "translation": "They say that when that bear sees us"
    },
    "10": {
        "startTime": 50.5,
        "endTime": 57.0,
        "transcript": "Tamaaggun ellait[nguluta] yuuluta ellmegcecicetun tangerqunegtekut",
        "translation": "When they see us living as themselves through that [saliva]"
    },
    "11": {
        "startTime": 59.0,
        "endTime": 65.0,
        "transcript": "Ullagluta tua-i piarkauvkenata waten pitangyuutekluta.",
        "translation": "They will will not come to us and attack us like this."
    },
    "12": {
        "startTime": 65.5,
        "endTime": 72.9,
        "transcript": "Tamatumek takaryuuterluteng ellaita nuameggnek minguutellemteńun kegginamteńun.",
        "translation": "They respect [and acknowledge] their saliva that we applied on our faces."
    },
    "13": {
        "startTime": 73.0,
        "endTime": 74.5,
        "transcript": "Au͡g'utun ayuquq.",
        "translation": "That's what it's like."
    },
    "14": {
        "startTime": 75.5,
        "endTime": 81.5,
        "transcript": "Tua-i tuacetun pilarait alikluku piarkauvkenateng.",
        "translation": "They do that and should not be afraid of it."
    },
    "15": {
        "startTime": 82.5,
        "endTime": 88.5,
        "transcript": "Okay, we asked the original question about the ritual of getting the first seal.",
        "translation": "Okay, we asked the original question about the ritual of getting the first seal."
    },
    "16": {
        "startTime": 91.0,
        "endTime": 98.0,
        "transcript": "Akaurtuq pinanrii[cata] makuneng agayulirteńeng makuneng pingata.",
        "translation": "It's been a long time since they've stopped doing that since they've turned to these priests."
    },
    "17": {
        "startTime": 98.5,
        "endTime": 101.5,
        "transcript": "Maa-i akaurtuq pinanrillrat.",
        "translation": "It's been a long time since they've stopped."
    },
    "18": {
        "startTime": 102.5,
        "endTime": 104.9,
        "transcript": "Wanigga kangia kangirqelluku,",
        "translation": "Explaining the meaning behind it,"
    },
    "19": {
        "startTime": 105.0,
        "endTime": 112.5,
        "transcript": "Kangia tauna ayagningellran tau͡gatnayaurtellrata kenglii wanigg' nalqigutekqataraqa, qanrutkeqataraqa.",
        "translation": "I am going to explain, talk about the reason that they have started doing that."
    },
    "20": {
        "startTime": 113.0,
        "endTime": 117.5,
        "transcript": "Ak'a-gguq au͡gani piyuitellruyaaqut, tau͡gatnayuitellruyaaqut.",
        "translation": "They say that a long time ago, people didn't do that."
    },
    "21": {
        "startTime": 117.5,
        "endTime": 125.5,
        "transcript": "Tau͡gaam taum mikelnguum atiin taum nakacugnun ayautesqellran",
        "translation": "But that child whose father sent him away in those bladders"
    },
    "22": {
        "startTime": 126.5,
        "endTime": 133.0,
        "transcript": "Ayautellrata taum, ayaucitellrata al'rrakurrluni uitaluni tamaani.",
        "translation": "When they sent him, he stayed there for a year."
    },
    "23": {
        "startTime": 133.1,
        "endTime": 138.5,
        "transcript": "Unguvalriit tamakut seal-at makliit ilagarluki uitallermini tau͡gani",
        "translation": "When he was there with the living creatures, the seals"
    },
    "24": {
        "startTime": 139.9,
        "endTime": 144.9,
        "transcript": "Tekicami utercami al'rrakuan tau͡gaam keyian tauna ayallni nallairngan",
        "translation": "When he returned only after [the year] of his stay had passed"
    },
    "25": {
        "startTime": 146.0,
        "endTime": 149.5,
        "transcript": "Tamatumeng tau͡gatnayaurcitellrullinii taum mikelnguum.",
        "translation": "That child had them start doing that."
    },
    "26": {
        "startTime": 151.5,
        "endTime": 156.0,
        "transcript": "Tau͡gaten mermeng piyaurcitellrullinii tamakut seal-at.",
        "translation": "He had them start giving water to those seals [they had caught]."
    },
    "27": {
        "startTime": 159.7,
        "endTime": 163.5,
        "transcript": "Taum tau͡ga tauna kengelkelluku piyaurtelliniit.",
        "translation": "During his time, they had started doing that [to seals]."
    },
    "28": {
        "startTime": 164.5,
        "endTime": 172.0,
        "transcript": "Taum mikelnguullermini ayallrem tamakunun unguvalriit nuniitnun ayagviatnun amavet kengllilluni",
        "translation": "When he was a child, he had gone where those living creatures go over there, staying with them"
    },
    "29": {
        "startTime": 172.1,
        "endTime": 176.5,
        "transcript": "Uterrluni-llu keyian al'rrakuni, al'rrakuq naangan.",
        "translation": "And he only returned after a year, when a year had passed."
    },
    "30": {
        "startTime": 177.0,
        "endTime": 182.0,
        "transcript": "Ayallni tauna nallairngan tau͡gaam tekitellrulliniuq. Tauna.",
        "translation": "He only came [back] when his trip had passed. That [child]."
    },
    "31": {
        "startTime": 183.0,
        "endTime": 185.0,
        "transcript": "Taum tau͡ga piyaurcitellrullinii.",
        "translation": "He had them start [giving water] to [seals]."
    },
    "32": {
        "startTime": 185.5,
        "endTime": 194.5,
        "transcript": "Tamakut seal-at pitaqaqamegteki nakacuit egcuunaki qerrutullruit.",
        "translation": "When people catch those seals, they don't discard their bladders but inflate them."
    },
    "33": {
        "startTime": 195.5,
        "endTime": 201.0,
        "transcript": "Taukut imkut seal-at tamalkuita nakacuit qerrurluki kiagpak-llu qemangqaluki.",
        "translation": "They inflated every bladder from those seals and kept them all summer."
    },
    "34": {
        "startTime": 201.5,
        "endTime": 204.9,
        "transcript": "Uksuaran, uksuaran-llu nutaan qagerqelluki",
        "translation": "And when fall came, they deflated them"
    },
    "35": {
        "startTime": 205.0,
        "endTime": 207.5,
        "transcript": "Cikum acianun [?] tayima atertelluki.",
        "translation": "Sending them with the current under the ice."
    },
    "36": {
        "startTime": 208.0,
        "endTime": 213.5,
        "transcript": "Tua-i-ll' tuatnatullruit tamakut seal-at pitaqaqamegteki nakacuit.",
        "translation": "And so, they would do that to the bladder of the seals they had caught."
    },
    "37": {
        "startTime": 213.6,
        "endTime": 217.4,
        "transcript": "Tua-i anernara tauna tuantelalliuq.",
        "translation": "I think its spirit is there."
    },
    "38": {
        "startTime": 217.5,
        "endTime": 220.5,
        "transcript": "Nakacuan iluancukluku pilarngatait.",
        "translation": "It seems they think it's inside its bladder."
    },
    "39": {
        "startTime": 221.5,
        "endTime": 223.5,
        "transcript": "Taum-gguq tua-i tai[?] allamiaku.",
        "translation": "They say that [the seal] returns the next year."
    },
    "40": {
        "startTime": 223.6,
        "endTime": 226.0,
        "transcript": "Tuaten qantuluteng pitullruut tamakut.",
        "translation": "That's what those people used to say."
    },
    "41": {
        "startTime": 226.8,
        "endTime": 234.5,
        "transcript": "Taukut tua-i pitaqetukai-gguq tua-i tauna nakacugaq tau͡gaam pitaqestektuminun utertetunia pitaqe[tuminun].",
        "translation": "They say that the ones who had caught those bladders, they return to the ones who caught them."
    },
    "42": {
        "startTime": 236.5,
        "endTime": 241.5,
        "transcript": "Tamatumek-am tuaten pinguarcelluku pitullrulliniit.",
        "translation": "They apparently thought that that's what they did."
    },
    "43": {
        "startTime": 242.5,
        "endTime": 249.5,
        "transcript": "Ataam taisqumaluki nakacuit-llu ayagtelluki Nakaciuraqameng.",
        "translation": "They would ask them to come again when they sent off the bladders during the Bladder Festival."
    },
    "44": {
        "startTime": 250.0,
        "endTime": 252.8,
        "transcript": "Qanrutekluku tauna-gguq tua-i…",
        "translation": "They say that that…"
    },
    "45": {
        "startTime": 252.9,
        "endTime": 255.5,
        "transcript": "Wanikuarqu. Una mumigterraarnauqa.",
        "translation": "Later. Let me translate this first."
    },
    "46": {
        "startTime": 259.0,
        "endTime": 259.9,
        "transcript": "Kurt Bell…",
        "translation": "Kurt Bell…"
    },
    "47": {
        "startTime": 260.0,
        "endTime": 264.0,
        "transcript": "…angalkum taukuk nulirqelriik yuak.",
        "translation": "…the shaman [send] the child of that couple."
    },
    "48": {
        "startTime": 264.9,
        "endTime": 271.5,
        "transcript": "Tua-i unguvayuunatek taukuk nulirqelriik yuk'ek ciungani. Tuquurluteng.",
        "translation": "In the past, that couple's children wouldn't stay alive. They kept dying."
    },
    "49": {
        "startTime": 271.6,
        "endTime": 275.5,
        "transcript": "Tua-i-llam tauna tua-i iliit irniara nutaan",
        "translation": "And then, one of their children."
    },
    "50": {
        "startTime": 276.5,
        "endTime": 285.4,
        "transcript": "Taum angalkum tuaten piyugluku taukuk yuak nakacugnun ilaulluku ayagcecugluku.",
        "translation": "That shaman wanted to do that to their2 child, include him with the bladders being sent."
    },
    "51": {
        "startTime": 285.5,
        "endTime": 287.9,
        "transcript": "Tua-i taum angalkum tuaten pivkarluku",
        "translation": "That shaman had hit to do that."
    },
    "52": {
        "startTime": 288.5,
        "endTime": 291.5,
        "transcript": "Tamakunun unguvalriit nuniitnun.",
        "translation": "Send him to the land of those living creatures."
    },
    "53": {
        "startTime": 293.0,
        "endTime": 297.0,
        "transcript": "Enenguluku tau͡gaam tauna unguvalriit nuniit tangerrluku elliin",
        "translation": "He, however, saw the land of those living creatures as a house."
    },
    "54": {
        "startTime": 297.5,
        "endTime": 303.5,
        "transcript": "Tua-i tekicami makut seal-at nuniitnun uksurpak.",
        "translation": "When he arrived at the land of these seals in the winter."
    },
    "55": {
        "startTime": 304.7,
        "endTime": 314.0,
        "transcript": "Ilaita-gguq-am tua-i nakukaqluku tauna, tauna ayagcetaulria nakacugteggun.",
        "translation": "They said that some of them picked on him, the one who was sent with the bladders."
    },
    "56": {
        "startTime": 314.5,
        "endTime": 320.0,
        "transcript": "Tamakut seal-at issurit-llu tua-i ayuqevkenateng tuani.",
        "translation": "Those seals and spotted seals were different there."
    },
    "57": {
        "startTime": 320.5,
        "endTime": 324.5,
        "transcript": "Ilaita-gguq-am tau͡gken kenkurluku piaqluku tua-i tauna.",
        "translation": "Yet, they said that some of them treated him with love."
    },
    "58": {
        "startTime": 325.0,
        "endTime": 329.0,
        "transcript": "Tua-i-gguq tamaani nutaan utertellmi kinguani pissuryaurcami",
        "translation": "They said that when he started hunting after he returned"
    },
    "59": {
        "startTime": 329.9,
        "endTime": 336.0,
        "transcript": "Elitaq'larai tamakut issurit wall'u nayiit.",
        "translation": "He would recognize those spotted or ringed seals."
    },
    "60": {
        "startTime": 336.7,
        "endTime": 340.0,
        "transcript": "Tua-i elitaqluki yugcetun wangkucicetun.",
        "translation": "He recognized them like us people."
    },
    "61": {
        "startTime": 340.5,
        "endTime": 345.0,
        "transcript": "Tua-i-gguq tamakut pissungellermini tamaani elitaq'laamiki",
        "translation": "They said that when he started hunting then, because he recognized them"
    },
    "62": {
        "startTime": 346.5,
        "endTime": 349.0,
        "transcript": "Pitpalarai cakneq tukniaqluni tua-i.",
        "translation": "He would strongly shoot them with arrows."
    },
    "63": {
        "startTime": 350.5,
        "endTime": 356.5,
        "transcript": "Pitgarluki-w' tua-i, narulkarluki-ll' call' cakneq tua-i elitaq'laamiki.",
        "translation": "He shot them with arrows and harpooned them hard because he recognized them."
    },
    "64": {
        "startTime": 356.6,
        "endTime": 359.0,
        "transcript": "Tua-i-am tuaten taman' ayuquq.",
        "translation": "That's what that's like."
    },
    "65": {
        "startTime": 359.5,
        "endTime": 364.0,
        "transcript": "He expanded on that thing about boy going out to the seals.",
        "translation": "He expanded on that thing about boy going out to the seals."
    },
    "66": {
        "startTime": 366.5,
        "endTime": 369.4,
        "transcript": "There was a man and a wife whose children would not live.",
        "translation": "There was a man and a wife whose children would not live."
    },
    "67": {
        "startTime": 369.5,
        "endTime": 373.0,
        "transcript": "They kept dying and dying [?]",
        "translation": "They kept dying and dying [?]"
    },
    "68": {
        "startTime": 373.5,
        "endTime": 378.0,
        "transcript": "And so, this one child [?]",
        "translation": "And so, this one child [?]"
    },
    "69": {
        "startTime": 379.5,
        "endTime": 384.0,
        "transcript": "[?] that child with a bladder out to the sea.",
        "translation": "[?] that child with a bladder out to the sea."
    },
    "70": {
        "startTime": 384.5,
        "endTime": 388.0,
        "transcript": "And so, that's what he did.",
        "translation": "And so, that's what he did."
    },
    "71": {
        "startTime": 389.0,
        "endTime": 394.0,
        "transcript": "And, and then that boy…",
        "translation": "And, and then that boy…"
    },
    "72": {
        "startTime": 395.0,
        "endTime": 399.5,
        "transcript": "…tau͡gatnaluni ayallrulliniuq tamaavet tungiitnun tau͡gatnayarturluki.",
        "translation": "…he traveled there like that to them to do that to them."
    },
    "73": {
        "startTime": 400.0,
        "endTime": 401.0,
        "transcript": "Okay, he…",
        "translation": "Okay, he…"
    },
    "74": {
        "startTime": 402.0,
        "endTime": 404.0,
        "transcript": "…caknerpak pivkenateng.",
        "translation": "…they didn't do it very excessively."
    },
    "75": {
        "startTime": 405.0,
        "endTime": 410.0,
        "transcript": "Tau͡gaam tayim' makut nallukeci tua-i-am tuaten pitulit.",
        "translation": "But you probably don't know those that do that."
    },
    "76": {
        "startTime": 410.1,
        "endTime": 411.9,
        "transcript": "Tarringaqa. (Ii-i).",
        "translation": "I understand it. (I see)."
    },
    "77": {
        "startTime": 412.5,
        "endTime": 415.0,
        "transcript": "What he's saying is that those people that were,",
        "translation": "Whats he's saying is that those people that were,"
    },
    "78": {
        "startTime": 418.5,
        "endTime": 422.5,
        "transcript": "Or, those seals that he recognized that were good to him,",
        "translation": "Or, those seals that he recognized that were good to him,"
    },
    "79": {
        "startTime": 422.9,
        "endTime": 425.5,
        "transcript": "He made sure that he made a good clean kill.",
        "translation": "He made sure that he made a good clean kill."
    },
    "80": {
        "startTime": 426.5,
        "endTime": 430.0,
        "transcript": "You know, really made sure that he did that.",
        "translation": "You know, really made sure that he did that."
    },
    "81": {
        "startTime": 430.5,
        "endTime": 435.5,
        "transcript": "It seems like this was a really important ceremony to go through.",
        "translation": "It seems like this was a really important ceremony to go through."
    },
    "82": {
        "startTime": 436.5,
        "endTime": 441.5,
        "transcript": "Ciin-gguq Kass'at tekiqercilluki tau͡gaten pinanrillruat?",
        "translation": "Why did they stop doing that after Caucasians arrived?"
    },
    "83": {
        "startTime": 445.0,
        "endTime": 449.5,
        "transcript": "Imkut agayulirtetangan pinanrirluki tuaten. (Ii-i).",
        "translation": "When the priests appeared, they stopped doing that. (Yes)."
    },
    "84": {
        "startTime": 450.9,
        "endTime": 453.0,
        "transcript": "Agayulirteńeng makuneng tau͡gaam pingan",
        "translation": "Only when these priests appeared"
    },
    "85": {
        "startTime": 454.0,
        "endTime": 458.5,
        "transcript": "Tamana tamaa-i makuneng agayulirteńeng pitangengan",
        "translation": "Because these priests appeared"
    },
    "86": {
        "startTime": 459.5,
        "endTime": 463.0,
        "transcript": "Tamana tau͡gatnayaraq pegtelqaat aturnanrirluku.",
        "translation": "They forsook that and stopped doing it."
    },
    "87": {
        "startTime": 463.1,
        "endTime": 467.0,
        "transcript": "Ii-i. Waten-qaa? Ukuk naliagneng?",
        "translation": "I see. Like this? Which of these2?"
    },
    "88": {
        "startTime": 467.7,
        "endTime": 471.0,
        "transcript": "Kayngukluku wall'u-qaa taqesqelqaaci?",
        "translation": "Were they ashamed of it or did they tell youpl to stop?"
    },
    "89": {
        "startTime": 472.5,
        "endTime": 477.5,
        "transcript": "Taqesqenrilengraiciteng tau͡ga tamana tamaa-i aturnanrillruat.",
        "translation": "Though they weren't told to stop, they stopped doing that."
    },
    "90": {
        "startTime": 479.0,
        "endTime": 483.0,
        "transcript": "Camun tamana aturyararteng tamatum seal-amun",
        "translation": "Their practice with a seal"
    },
    "91": {
        "startTime": 484.0,
        "endTime": 486.0,
        "transcript": "Atutukseng tamana aturnanrillruat.",
        "translation": "They stopped adhering to their practice."
    },
    "92": {
        "startTime": 486.5,
        "endTime": 489.5,
        "transcript": "I'll do one, and I hear something different over there.",
        "translation": "I'll do one, and I hear something different over there."
    },
    "93": {
        "startTime": 490.0,
        "endTime": 496.0,
        "transcript": "But Kurt Bell says that after the missionaries came, they stopped on their own.",
        "translation": "But Kurt Bell says that after the missionaries came, they stopped on their own."
    },
    "94": {
        "startTime": 499.5,
        "endTime": 500.5,
        "transcript": "Qanqeryugngaunga-qaa?",
        "translation": "May I say something?"
    },
    "95": {
        "startTime": 500.6,
        "endTime": 501.5,
        "transcript": "Ii-i. (Ii-i).",
        "translation": "Yes. (Okay)."
    },
    "96": {
        "startTime": 502.0,
        "endTime": 512.5,
        "transcript": "Au͡g'umi wani, yaa, kegginaanun taqukat, black bear-at wall'u brown bear-at",
        "translation": "In what they said, yes, to the bear's faces, black bears or brown bears"
    },
    "97": {
        "startTime": 513.5,
        "endTime": 519.0,
        "transcript": "Qanra wani, maa-i qanranek piluteng kegginaa pitullinikiit.",
        "translation": "It's mouth, they take [saliva] from its mouth and apply it to its face."
    },
    "98": {
        "startTime": 520.5,
        "endTime": 522.9,
        "transcript": "Wiinga tan'gaurluulua…",
        "translation": "When I was a boy…"
    },
    "99": {
        "startTime": 523.0,
        "endTime": 525.0,
        "transcript": "Kituuyit? (Edward Weiss).",
        "translation": "Who are you? (Edward Weiss)."
    },
    "100": {
        "startTime": 528.0,
        "endTime": 533.0,
        "transcript": "Waten pillruatnga au͡g'um ap'ama:",
        "translation": "My grandfather used to tell me this:"
    },
    "101": {
        "startTime": 535.5,
        "endTime": 538.1,
        "transcript": "Tan'gerliq tuqulluku nutgaarluku",
        "translation": "After shooting and killing a black bear"
    },
    "102": {
        "startTime": 538.2,
        "endTime": 546.0,
        "transcript": "Tua-i-ll' tuaten, waten qamaken nuaganek kegginaqa mingugtelluku unatenka-llu.",
        "translation": "And then like that, I should get saliva from inside [its mouth] and appy it to my face and my hands."
    },
    "103": {
        "startTime": 547.0,
        "endTime": 555.0,
        "transcript": "Tua-i-ll' waten qanrullua: anglikuma-gguq pissuryaureskuma",
        "translation": "And then said this to me: when I grow up and start hunting"
    },
    "104": {
        "startTime": 557.0,
        "endTime": 567.0,
        "transcript": "Pitsaqevkenii-gguq tan'gerlim wall'u tamakut brown bear-am akngirrluni tegukunia",
        "translation": "Should an injured black bear or those brown bears take me"
    },
    "105": {
        "startTime": 567.5,
        "endTime": 572.0,
        "transcript": "Kegginaqa-gguq tangerciqaa nuaminek pimaluni.",
        "translation": "It will see my face with its saliva on it."
    },
    "106": {
        "startTime": 572.1,
        "endTime": 575.5,
        "transcript": "Taumek-gguq aneryaarvikngaitaanga.",
        "translation": "He said that that's why it won't breathe on me."
    },
    "107": {
        "startTime": 577.0,
        "endTime": 586.5,
        "transcript": "Aneryaallrit, nuagit black bear-at tukniqapiartut nuagit yugnun.",
        "translation": "Their breath, black bear saliva is extremely potent on people."
    },
    "108": {
        "startTime": 586.9,
        "endTime": 591.5,
        "transcript": "Taumek waten aneryaarvikluku tuqutelallinikait kegginait puvvluki.",
        "translation": "That's why they evidently kill people by breathing on them like this and making their faces swell."
    },
    "109": {
        "startTime": 592.0,
        "endTime": 593.5,
        "transcript": "Tuaten-gguq pingaitaanga.",
        "translation": "He said that it won't do that to me."
    },
    "110": {
        "startTime": 593.6,
        "endTime": 602.5,
        "transcript": "Tua-i-llu kinguani qaillun tayim' allrakunglua, 25-aarlua",
        "translation": "And then after that when I had reached a certain age, 25"
    },
    "111": {
        "startTime": 604.0,
        "endTime": 609.0,
        "transcript": "Nutecurlagluku tan'gerlim tegullruyaaqaanga, nutka teguluku waten.",
        "translation": "I missed a killing shot on a brown bear and it took me, took my gun like this."
    },
    "112": {
        "startTime": 610.5,
        "endTime": 618.0,
        "transcript": "Tau͡gaam kegginamnun aneryaallrunrituq, tau͡gaam waten ulurlua aneryaaraqluni.",
        "translation": "However, it didn't breathe on my face, but turned like this and breathed."
    },
    "113": {
        "startTime": 618.1,
        "endTime": 624.0,
        "transcript": "Tamaa-i tamana alerquutektulliniat, maa-i-llu cali.",
        "translation": "That's what they instructed, even now."
    },
    "114": {
        "startTime": 625.5,
        "endTime": 627.5,
        "transcript": "Ava[?]",
        "translation": "Just now [?]"
    },
    "115": {
        "startTime": 628.5,
        "endTime": 635.5,
        "transcript": "Okay, that's [?] why from up the Kuskokwim. He said when his grandfather…",
        "translation": "Okay, that's [?] why from up the Kuskokwim. He said when his grandfather…"
    },
    "116": {
        "startTime": 638.0,
        "endTime": 647.5,
        "transcript": "Elliin tangrruallrani elpeci older men",
        "translation": "As [s]he imagines you older men"
    },
    "117": {
        "startTime": 649.5,
        "endTime": 655.5,
        "transcript": "Umyuarteqtullrulliniuci respect-arluki qigcikluki pitarkat.",
        "translation": "You apparently respect, qigcikluki, animals that we hunt."
    },
    "118": {
        "startTime": 656.0,
        "endTime": 660.0,
        "transcript": "Maa-i-rpak-gguq-qaa umyuarteqlerpecini",
        "translation": "[S]he said that now, in your opinions"
    },
    "119": {
        "startTime": 660.5,
        "endTime": 668.0,
        "transcript": "Makut kinguliaci tau͡gaten, tau͡gaten-gguq-qaa ayuqluteng piut elpecicetun?",
        "translation": "Do yourpl descendants do that as youpl are?"
    },
    "120": {
        "startTime": 668.5,
        "endTime": 670.5,
        "transcript": "Wall'u-gguq-qaa pinritut?",
        "translation": "Or are they not doing that?"
    },
    "121": {
        "startTime": 671.0,
        "endTime": 678.5,
        "transcript": "Pinrilkata-gguq waten umyuartequci pitarkat nangnayukluki?",
        "translation": "If they're not, [s]he's asking if youpl think that the animals we hunt will decline."
    },
    "122": {
        "startTime": 682.5,
        "endTime": 685.0,
        "transcript": "Wanigga wii…",
        "translation": "Now, I…"
    },
    "123": {
        "startTime": 685.1,
        "endTime": 688.0,
        "transcript": "…cuaqaqataraqa apyutii.",
        "translation": "…I am going to briefly [leave] her question."
    },
    "124": {
        "startTime": 689.5,
        "endTime": 698.0,
        "transcript": "Makut seal-at makut un'um imarpiim pitarkai nangllerkaitneng umyugartuyuitua",
        "translation": "I am not worried about the depletion of these seals, the animals down from the ocean that we hunt"
    },
    "125": {
        "startTime": 700.8,
        "endTime": 708.0,
        "transcript": "Makuneng tau͡gaam tengmiat makut piyagait, kayanguit.",
        "translation": "But these chicks, eggs, of these birds."
    },
    "126": {
        "startTime": 709.5,
        "endTime": 720.0,
        "transcript": "Makut yug'enka wii irnianka inerqutuanka waten irniarita tukellrata nalliini:",
        "translation": "I admonish my children, my offspring when their chicks hatch:"
    },
    "127": {
        "startTime": 722.0,
        "endTime": 730.5,
        "transcript": "Angu nutegyasqevkenaku, tamakut-llu piyagauluki pisqevkenaki mikelnguuluki.",
        "translation": "Do not hunt when they are chicks, when they are young."
    },
    "128": {
        "startTime": 732.0,
        "endTime": 739.0,
        "transcript": "Tau͡gaam piyaaqengraan, kayimyaaqengraan tamakut aanait waten carraugaqata irniarit",
        "translation": "But even when they hatch, their mothers, when their chicks are small and young like this"
    },
    "129": {
        "startTime": 739.9,
        "endTime": 742.5,
        "transcript": "Inerqutuanka tau͡ga wii pisqevkenaki.",
        "translation": "I admonish them against hunting them."
    },
    "130": {
        "startTime": 743.8,
        "endTime": 752.5,
        "transcript": "Tamakut mikelnguut wii-ll' irnianka tamakut tau͡gaten ayuqsugnarqut tengmiatun piyagartun.",
        "translation": "Those young and my children are probably like those chicks."
    },
    "131": {
        "startTime": 753.9,
        "endTime": 756.0,
        "transcript": "Tamakut pitekluki inerqutuanka",
        "translation": "That's why I admonish them"
    },
    "132": {
        "startTime": 757.0,
        "endTime": 763.0,
        "transcript": "Irniaqenrilengramki tamakut kayanguit tengmiat piyagait tukraqata.",
        "translation": "Even though the [chicks] when the birds' eggs hatch are not my children."
    },
    "133": {
        "startTime": 764.5,
        "endTime": 770.5,
        "transcript": "Angturriqvaaraqata-llu kia yuum malingcarluku ayauskaku, ayauteqatallinikaku",
        "translation": "And when they're getting larger, if someone takes them away to tame them, is apparently going to take them away"
    },
    "134": {
        "startTime": 770.9,
        "endTime": 777.0,
        "transcript": "Inerqurciqaqa angu aanii aanak ukuk qaqillukek angu pisqevkenaku.",
        "translation": "I will admonish him against killing them all, including the mother [and father]."
    },
    "135": {
        "startTime": 778.5,
        "endTime": 785.0,
        "transcript": "Tuqutesqevkenakek aanak taukuk aulukestairuciqniluki taukut irniari.",
        "translation": "I tell them not to kill the mother [and father] saying that their chicks will have no one to take care of them anymore."
    },
    "136": {
        "startTime": 786.0,
        "endTime": 788.0,
        "transcript": "Tapirviitniluki makut naruyat.",
        "translation": "I tell them that these seagulls cannot be taken care of by anything else."
    },
    "137": {
        "startTime": 791.0,
        "endTime": 798.0,
        "transcript": "Naklegnaqniluki tamakut mikelnguuniluki aanaituraluki tamana aulukestaraunaki pillerkait.",
        "translation": "I tell them that they are young and pitiful should they lose their mothers, their caretakers."
    },
    "138": {
        "startTime": 799.8,
        "endTime": 802.0,
        "transcript": "Taumeng tang inerqutuanka.",
        "translation": "I admonish them about that."
    },
    "139": {
        "startTime": 816.5,
        "endTime": 829.0,
        "transcript": "But he tells his children about the birds that, when birds have this, you know, when the eggs start hatching",
        "translation": "But he tells his children about the birds that, when birds have this, you know, when the eggs start hatching"
    },
    "140": {
        "startTime": 829.1,
        "endTime": 835.0,
        "transcript": "And the mothers [?]",
        "translation": "And the mothers [?]"
    },
    "141": {
        "startTime": 835.9,
        "endTime": 838.5,
        "transcript": "Tua-llu cakananinrituq.",
        "translation": "And then it's no different."
    },
    "142": {
        "startTime": 839.0,
        "endTime": 847.0,
        "transcript": "Wangkuta pissulallruukut, tua-i-llu aanamta pitarput kencikluku.",
        "translation": "We used to hunt, and then our mothers would rever our catch."
    },
    "143": {
        "startTime": 848.0,
        "endTime": 849.5,
        "transcript": "Quyakluku cakneq.",
        "translation": "They were very thankful for it."
    },
    "144": {
        "startTime": 849.6,
        "endTime": 856.5,
        "transcript": "Tua-llu maa-i wangkuta aataurtellriani, taum-llu tua-i aanaulriim nallunritai qetunrangqerrami",
        "translation": "And now, we who have become fathers, and she who is a mother knows them because she has sons"
    },
    "145": {
        "startTime": 856.6,
        "endTime": 861.9,
        "transcript": "Qetunrani qangqiirtaqan cakneq quyakluku ciuniularai.",
        "translation": "When her son catches ptarmigans, she is very thankful for them and welcomes them."
    },
    "146": {
        "startTime": 862.5,
        "endTime": 864.9,
        "transcript": "Tua-i ikgelkevkenaku.",
        "translation": "She doesn't think it's too little."
    },
    "147": {
        "startTime": 865.0,
        "endTime": 870.0,
        "transcript": "Pitai tamalkuita quyakluki kencikluki-llu.",
        "translation": "She is thankful for and reveres all of his catches."
    },
    "148": {
        "startTime": 870.1,
        "endTime": 878.0,
        "transcript": "Sagcetevkenaki [?]mun-llu pisqevkenaki avaken inerquutekngamteńek. Tua-i.",
        "translation": "She doesn't leave them scattered or doesn't let them go to the [?] as we were always admonished. That's all."
    },
    "149": {
        "startTime": 881.0,
        "endTime": 882.5,
        "transcript": "Ernerpak maa-i-rpak…",
        "translation": "Now, these days…"
    },
    "150": {
        "startTime": 884.0,
        "endTime": 886.0,
        "transcript": "…wiinga tamana nalluaqa.",
        "translation": "…I don't know that."
    },
    "151": {
        "startTime": 886.5,
        "endTime": 894.0,
        "transcript": "Wangkuta tang aanaulriani ayagyua[?] qanrutestailngukut.",
        "translation": "We mothers, you see, [who are] young[er than you] have no one to instruct us."
    },
    "152": {
        "startTime": 895.0,
        "endTime": 904.5,
        "transcript": "Atawauyartuq-qaa makut maani qanerceskuvciki KYUK news",
        "translation": "Would it be well if you had them instruct here on the KYUK news?"
    },
    "153": {
        "startTime": 905.5,
        "endTime": 911.0,
        "transcript": "Or, time-amek cikiqerluki ayuqucirturluta wangkuta.",
        "translation": "Or, give them time to instruct us."
    },
    "154": {
        "startTime": 911.5,
        "endTime": 915.5,
        "transcript": "Yuungnaqellriit amllertut irniaput. Nalluukut.",
        "translation": "We have many children who are trying to make a living. We don't know."
    },
    "155": {
        "startTime": 916.5,
        "endTime": 918.5,
        "transcript": "Wiinga-llu irnianka nalluvkaranka.",
        "translation": "I am also leaving my children in the dark."
    },
    "156": {
        "startTime": 919.0,
        "endTime": 923.0,
        "transcript": "Tua-i-wa niicuilama akaurcan aanairuyuciqa.",
        "translation": "It's because I've never heard them since I lost my mother so long ago."
    },
    "157": {
        "startTime": 923.8,
        "endTime": 929.0,
        "transcript": "Ak'allaraat makut wiinga qalartellrit assikanka. Piciugut.",
        "translation": "I like when these old people speak. They are true."
    },
    "158": {
        "startTime": 929.5,
        "endTime": 933.0,
        "transcript": "Maa-i cali piuyaaqut, tau͡gaam tamartut.",
        "translation": "It's still [practiced] now, but it's disappearing."
    },
    "159": {
        "startTime": 933.5,
        "endTime": 937.0,
        "transcript": "Kass'at elitnaurutet pugelriit iptait.",
        "translation": "The Western teachings that have appeared are eclipsing them."
    },
    "160": {
        "startTime": 938.5,
        "endTime": 942.0,
        "transcript": "Atawauyartuq time-amek Kass'amta cikiqaqakut.",
        "translation": "It would be well if our Caucasian partners gave us time."
    },
    "161": {
        "startTime": 942.5,
        "endTime": 953.0,
        "transcript": "KYUK radio wall'u news-atgun ciulirneq qanqaquni elitnaurluki irniaput ikayurciqaakut.",
        "translation": "If an elder speaks on KYUK radio or on the news, teaching our children, [s]he will help us."
    },
    "162": {
        "startTime": 955.5,
        "endTime": 963.0,
        "transcript": "Time-amek cikircetkatki quyanaqsartut amllerkun elicartuq.",
        "translation": "We would be thankful if they gave them time, and they would learn a lot."
    },
    "163": {
        "startTime": 965.0,
        "endTime": 966.7,
        "transcript": "Quyana Larissa.",
        "translation": "Thank you, Larissa."
    },
    "164": {
        "startTime": 968.0,
        "endTime": 975.0,
        "transcript": "Alerqutuitkut-am pissuqataqumta tan'gerlit…",
        "translation": "When we're going to hunt, they instruct us concerning black bears…"
    },
    "165": {
        "startTime": 980.0,
        "endTime": 985.0,
        "transcript": "Muragmek ayarurkamteńek pisqelluta.",
        "translation": "They tell us to make a walking staff out of wood."
    },
    "166": {
        "startTime": 990.0,
        "endTime": 997.0,
        "transcript": "…tua-i-w' ayaruq uksuarmi-w' atuulria tua-i mamkilngurmun cikum wall'u aarnarqellrianun.",
        "translation": "…a walking stick is useful in the fall for thin ice or dangerous things."
    },
    "167": {
        "startTime": 997.5,
        "endTime": 1003.0,
        "transcript": "Tauna-am avani qau͡gkumiuni alerquutnguuq.",
        "translation": "That was an instruction back then for the people up north."
    },
    "168": {
        "startTime": 1003.5,
        "endTime": 1008.0,
        "transcript": "Ingrinun canegnun pissuqataqumta wall'u ayagakumta",
        "translation": "When we're going to hunt in the mountains, in the grass, or when we travel"
    },
    "169": {
        "startTime": 1008.5,
        "endTime": 1011.5,
        "transcript": "Ayaruq tauna tegumiaquraasqelluku.",
        "translation": "They told us to keep holding that walking staff."
    },
    "170": {
        "startTime": 1013.0,
        "endTime": 1020.5,
        "transcript": "Tua-i-llam ayagpakarluta tan'gerlim curukarciqliniakut.",
        "translation": "And as we travel, a black bear will eventually attack us."
    },
    "171": {
        "startTime": 1022.5,
        "endTime": 1026.5,
        "transcript": "Tua-i-gguq makut tan'gerlit yugtun ayuqut.",
        "translation": "They say that these black bears are like people."
    },
    "172": {
        "startTime": 1028.0,
        "endTime": 1030.5,
        "transcript": "Unatemegteggun waten tegutuut.",
        "translation": "They take things with their forepaws like this."
    },
    "173": {
        "startTime": 1031.6,
        "endTime": 1039.5,
        "transcript": "Egmian-gguq wani nutegput teguvailgaku ayarumek cikiqilarput.",
        "translation": "They say that before it takes our gun, we should immediate give it a staff."
    },
    "174": {
        "startTime": 1039.6,
        "endTime": 1042.5,
        "transcript": "Tua-i-gguq taum anirturciqaakut.",
        "translation": "They said that that will save us."
    },
    "175": {
        "startTime": 1043.0,
        "endTime": 1047.5,
        "transcript": "Nutaan cikirluku teguqerarkauluku tayim' wangkuta nutgarkauluku.",
        "translation": "We give it, it will take it, and we will shoot it."
    },
    "176": {
        "startTime": 1048.5,
        "endTime": 1050.0,
        "transcript": "Imumi tamaani.",
        "translation": "That was a long time ago."
    },
    "177": {
        "startTime": 1056.0,
        "endTime": 1060.0,
        "transcript": "…angalkungqellruukut, angalkungqelallrulliniukut.",
        "translation": "…we had shamans, we apparently had shamans"
    },
    "178": {
        "startTime": 1062.5,
        "endTime": 1067.5,
        "transcript": "Tamakut tamaani piciruitnek wangkuta ap'laraput.",
        "translation": "We call those superstitions."
    },
    "179": {
        "startTime": 1068.5,
        "endTime": 1073.0,
        "transcript": "Yaa, piciruitniluki, tua-i angalkurtauluni.",
        "translation": "Yes, we say they are superstitious, originating from shamans."
    },
    "180": {
        "startTime": 1074.0,
        "endTime": 1078.0,
        "transcript": "Wait, wii tarringenritaqa tauna. Piciruiq?",
        "translation": "Wait, I don't understand that. Piciruiq?"
    },
    "181": {
        "startTime": 1079.0,
        "endTime": 1082.5,
        "transcript": "Iciw' tua-i piciuvkenani angalkurtauluni tamana.",
        "translation": "You know, that's not real and originates from shamans."
    },
    "182": {
        "startTime": 1082.6,
        "endTime": 1086.0,
        "transcript": "Angalkuq tuunrangayagtauluni wangkuta apqemteńek.",
        "translation": "We say that shamans are of the devil."
    },
    "183": {
        "startTime": 1086.5,
        "endTime": 1092.0,
        "transcript": "Tamakut tamaa-i ukvengamta mat'umun Agayutmun",
        "translation": "When we acquired faith in God"
    },
    "184": {
        "startTime": 1092.5,
        "endTime": 1097.0,
        "transcript": "Tamakut tamaa-i amlleret iinrut-llu pegingaut tayima.",
        "translation": "Many of those and traditional medicines are forsaken."
    },
    "185": {
        "startTime": 1097.5,
        "endTime": 1099.0,
        "transcript": "Pegingaurtut.",
        "translation": "They're forsaken."
    },
    "186": {
        "startTime": 1100.0,
        "endTime": 1107.0,
        "transcript": "Tua-llu maa-i nunamteńi unani ceńarmiuni",
        "translation": "And now in our village down among the coastal people"
    },
    "187": {
        "startTime": 1109.8,
        "endTime": 1116.0,
        "transcript": "Man'a maklagcaraq pegcuitarput.",
        "translation": "We haven't forsaken the practice [surrounding] catching seals."
    },
    "188": {
        "startTime": 1117.0,
        "endTime": 1132.0,
        "transcript": "Maa-i ayagyuarunrilengraan-llu allrakuaqan up'nerkami pitqerraarqan maklagmek, cali allragni pitellruluni",
        "translation": "When this person, even if he's not young, catches the first seal in the spring, having also caught one the previous year"
    },
    "189": {
        "startTime": 1133.6,
        "endTime": 1137.6,
        "transcript": "Ciuqlirmek angun pitqerraarturarqan qamigatuli",
        "translation": "When the first one who goes seal hunting catches the first [seal]"
    },
    "190": {
        "startTime": 1140.0,
        "endTime": 1145.0,
        "transcript": "Maa-i apqemteńek uqiqurrlainalartuq maklagmek taumek.",
        "translation": "They always distrubute that seal, uqiqurluni as we call it."
    },
    "191": {
        "startTime": 1145.1,
        "endTime": 1152.9,
        "transcript": "Maklak tua-i ciuqliq pitaa yugnun tamalkuan aruqutketuuq kemggartuumaan.",
        "translation": "Every part of the first seal that he catches is distributed to everyone including what meat it has."
    },
    "192": {
        "startTime": 1154.7,
        "endTime": 1159.5,
        "transcript": "Tua-i ciuqliq tua-i ayagyuarunrilengraan.",
        "translation": "The first [catch], even if he's not young."
    },
    "193": {
        "startTime": 1159.6,
        "endTime": 1164.5,
        "transcript": "Allamineq tamak'acagaan maa-i cali pegteksaunaku man'a tekilluku.",
        "translation": "Every single year, we still haven't forsaken that to this day."
    },
    "194": {
        "startTime": 1165.5,
        "endTime": 1175.0,
        "transcript": "Tauna tua-i maklak taguskatgu itumlluku tamalkuan aruqutkaqluku kemggartuumaan.",
        "translation": "When they bring that seal on land and [butcher] it into pieces, they distribute all of it, including what meat it has."
    },
    "195": {
        "startTime": 1176.5,
        "endTime": 1179.0,
        "transcript": "Tuaten tua-i wagg'uq uqiqurluteng.",
        "translation": "That's what they call uqiqurluteng."
    },
    "196": {
        "startTime": 1179.5,
        "endTime": 1186.0,
        "transcript": "Au͡gna tua-i pitangyu[?], wangkuta-ll' [?]",
        "translation": "That [?first] catch, we also [?]"
    },
    "197": {
        "startTime": 1187.0,
        "endTime": 1190.0,
        "transcript": "Tuaten tua-i pituuq. Maa-i pegteksaituq.",
        "translation": "That's what happens. We haven't forsaken it."
    },
    "198": {
        "startTime": 1190.5,
        "endTime": 1196.0,
        "transcript": "Maa-i-am atam nunamteńi tuatna[?].",
        "translation": "You see, [we do] that in our village."
    },
    "199": {
        "startTime": 1197.0,
        "endTime": 1203.0,
        "transcript": "Una tua-i ciuqlirmek maklageskan tua-i ellait neryuniurluteng nunat arnat.",
        "translation": "When this person catches the first seal, the women of the village wait eagerly."
    },
    "200": {
        "startTime": 1203.5,
        "endTime": 1205.5,
        "transcript": "Tauna-llu kemga kiingan pivkenaku.",
        "translation": "And not only its meat."
    },
    "201": {
        "startTime": 1205.6,
        "endTime": 1207.0,
        "transcript": "Uqua canek tau͡gaam tapirluku.",
        "translation": "They include other things to its blubber."
    },
    "202": {
        "startTime": 1208.0,
        "endTime": 1213.0,
        "transcript": "[?]",
        "translation": "[?]"
    },
    "203": {
        "startTime": 1214.0,
        "endTime": 1215.0,
        "transcript": "Lumarrarnek-llu tua-i.",
        "translation": "And pieces of cloth."
    },
    "204": {
        "startTime": 1216.5,
        "endTime": 1223.0,
        "transcript": "Tauna kiirrainaan pivkenaku, tua-i Kass'allararnek tapirluku [?].",
        "translation": "They don't give it by itself, but add Western things to it [?]."
    },
    "205": {
        "startTime": 1224.0,
        "endTime": 1230.0,
        "transcript": "Okay, he's also responding to your earlier question if those rituals are still…",
        "translation": "Okay, he's also responding to your earlier question if those rituals are still…"
    },
    "206": {
        "startTime": 1231.0,
        "endTime": 1235.5,
        "transcript": "For him, this, Phillip Moses from Toksook Bay said",
        "translation": "For him, this, Phillip Moses from Toksook Bay said"
    },
    "207": {
        "startTime": 1236.5,
        "endTime": 1244.0,
        "transcript": "They still do the first seal, not only the first young man seal, but the first maklak of the season.",
        "translation": "They still do the first seal, not only the first young man seal, but the first beaded seal of the season."
    },
    "208": {
        "startTime": 1244.9,
        "endTime": 1252.5,
        "transcript": "What they still do is, they still, the women look forward to this.",
        "translation": "What they still do is, they still, the women look forward to this."
    },
    "209": {
        "startTime": 1253.5,
        "endTime": 1258.5,
        "transcript": "They cut the maklak up into blubber and meat",
        "translation": "They cut the bearded seal up into blubber and meat"
    },
    "210": {
        "startTime": 1259.5,
        "endTime": 1266.0,
        "transcript": "And then they call the whole village to come for the share of the whole thing.",
        "translation": "And then they call the whole village to come for the share of the whole thing."
    },
    "211": {
        "startTime": 1266.5,
        "endTime": 1267.5,
        "transcript": "So, they don't keep it for themselves.",
        "translation": "So, they don't keep it for themselves."
    },
    "212": {
        "startTime": 1267.6,
        "endTime": 1272.0,
        "transcript": "What they do is they give it away to everybody else in the village.",
        "translation": "What they do is they give it away to everybody else in the village."
    },
    "213": {
        "startTime": 1272.5,
        "endTime": 1275.5,
        "transcript": "And not just the pieces of the seal,",
        "translation": "And not just the pieces of the seal,"
    },
    "214": {
        "startTime": 1275.6,
        "endTime": 1280.5,
        "transcript": "But they also today include, like, things they buy from the store:",
        "translation": "But they also today include, like, things they buy from the store:"
    },
    "215": {
        "startTime": 1281.0,
        "endTime": 1285.0,
        "transcript": "Pieces of cloth, or crackers, or whatever, you know, whatever…",
        "translation": "Pieces of cloth, or crackers, or whatever, you know, whatever…"
    },
    "216": {
        "startTime": 1288.0,
        "endTime": 1295.0,
        "transcript": "Ca-gguq imna pitekluku tamana maklak cikiutektuatgu ilameggnun?",
        "translation": "She asked the reason behind giving that bearded seal to the others."
    },
    "217": {
        "startTime": 1295.5,
        "endTime": 1300.0,
        "transcript": "Tua-i waten piciryaraqluku waten:",
        "translation": "This is their tradition:"
    },
    "218": {
        "startTime": 1301.0,
        "endTime": 1310.0,
        "transcript": "Kina imna ciuqlirmi waten up'nerkami piaqami neryutuuq tamakunek maklagnek.",
        "translation": "When the first one catches a seal in the spring like this, he wants to eat those bearded seals."
    },
    "219": {
        "startTime": 1311.0,
        "endTime": 1315.0,
        "transcript": "Tamana pitekluku neryutullrat",
        "translation": "Because they want to eat"
    },
    "220": {
        "startTime": 1316.5,
        "endTime": 1323.0,
        "transcript": "Avani-w' pitekluki pituameng waten uksumi tamakunek maklagnek piyuitut.",
        "translation": "Back then, since they did it for them, they don't [eat] bearded seals in the winter like this."
    },
    "221": {
        "startTime": 1327.0,
        "endTime": 1332.5,
        "transcript": "Tamana meaning-aangqertuq apyutii kenkuyutnguluni.",
        "translation": "The meaning behind what she asked is showing love for each other."
    },
    "222": {
        "startTime": 1333.5,
        "endTime": 1337.0,
        "transcript": "Kenkuyun tua-i meaning-aara tauna. Yaa.",
        "translation": "Its meaning is love for each other. Yes."
    },
    "223": {
        "startTime": 1337.5,
        "endTime": 1341.0,
        "transcript": "Yaa, tauna. Tamakuuguq. Kenkauguq.",
        "translation": "Yes, that. That's what it is. It's love."
    },
    "224": {
        "startTime": 1342.0,
        "endTime": 1347.0,
        "transcript": "Okay, you asked for the reason for this sharing, you know?",
        "translation": "Okay, you asked for the reason for this sharing, you know?"
    },
    "225": {
        "startTime": 1347.5,
        "endTime": 1350.5,
        "transcript": "He said, Phillip Moses said…",
        "translation": "He said, Phillip Moses said…"
    },
    "226": {
        "startTime": 1351.0,
        "endTime": 1356.0,
        "transcript": "…kencikiyaramek waniwa 10-12 caliarkaullruukut.",
        "translation": "…we were going to work on showing reverence from 10-12."
    },
    "227": {
        "startTime": 1357.0,
        "endTime": 1361.0,
        "transcript": "Waniwa tua-i wii qanqaqatartua carrarmek 12 kelakatallinian.",
        "translation": "I'm going to talk a little since it's nearing 12 o'clock."
    }
};